import { createSlice } from '@reduxjs/toolkit';

import { getType } from 'typesafe-actions';

import { EntityTradeValuesData, EntityTransactionValue } from '../types';

import * as entityPortfolioActions from './actions';

export interface EntityTradeValuesState {
  entityTransactionValues: {
    data: EntityTransactionValue;
    loading: boolean;
  };
  individualTradeValue: {
    data: EntityTradeValuesData[];
    loading: boolean;
  };
}

const initialState: EntityTradeValuesState = {
  entityTransactionValues: {
    data: {},
    loading: false,
  },
  individualTradeValue: {
    data: [],
    loading: false,
  },
};

const entityTradeValuesSlice = createSlice({
  name: 'entityTradeValues',
  initialState,
  reducers: {
    clearEntityTransactionValues: (state) => {
      state.entityTransactionValues.data = {};
      state.entityTransactionValues.loading = false;
      state.individualTradeValue.data = [];
      state.individualTradeValue.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getType(entityPortfolioActions.getEntityTransactionValues.request),
        (state) => {
          state.entityTransactionValues.loading = true;
        },
      )
      .addCase(
        getType(entityPortfolioActions.getEntityTransactionValues.success),
        (state, action: any) => {
          state.entityTransactionValues.data = action.payload.data;
          state.entityTransactionValues.loading = false;
        },
      )
      .addCase(
        getType(entityPortfolioActions.getEntityTransactionValues.failure),
        (state) => {
          state.entityTransactionValues.loading = false;
        },
      )
      // individual trade value
      .addCase(
        getType(entityPortfolioActions.getPortfolioTradeValues.request),
        (state) => {
          state.individualTradeValue.loading = true;
        },
      )
      .addCase(
        getType(entityPortfolioActions.getPortfolioTradeValues.success),
        (state, action: any) => {
          state.individualTradeValue.data = action.payload.data;
          state.individualTradeValue.loading = false;
        },
      )
      .addCase(
        getType(entityPortfolioActions.getPortfolioTradeValues.failure),
        (state) => {
          state.individualTradeValue.loading = false;
        },
      );
  },
});

export const { clearEntityTransactionValues } = entityTradeValuesSlice.actions;

export const entityTradeValuesReducer = entityTradeValuesSlice.reducer;
